import Mask from '../src/Mask';
export default Mask;
